var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7602 1.2809L9.57883 8.78006C9.50285 8.84978 9.41262 8.9051 9.3133 8.94284C9.21398 8.98058 9.10752 9 9 9C8.89248 9 8.78602 8.98058 8.6867 8.94284C8.58738 8.9051 8.49715 8.84978 8.42116 8.78006L0.239761 1.2809C0.0862446 1.14018 0 0.949334 0 0.750333C0 0.551332 0.0862446 0.360482 0.239761 0.219767C0.393277 0.0790523 0.60149 0 0.818595 0C1.0357 0 1.24391 0.0790523 1.39743 0.219767L9 7.1893L16.6026 0.219767C16.6786 0.150092 16.7688 0.0948231 16.8681 0.0571154C16.9675 0.0194076 17.0739 0 17.1814 0C17.2889 0 17.3953 0.0194076 17.4947 0.0571154C17.594 0.0948231 17.6842 0.150092 17.7602 0.219767C17.8363 0.289442 17.8965 0.372158 17.9377 0.463193C17.9788 0.554227 18 0.651798 18 0.750333C18 0.848868 17.9788 0.946439 17.9377 1.03747C17.8965 1.12851 17.8363 1.21122 17.7602 1.2809Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/CaretDown.7c4af147b89f006cb2ba0f9ba9dd30b8.svg";
export { ForwardRef as ReactComponent };